/**
 * PromotionDetailPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, InputFormTable, Table } from 'components';
import { Button } from 'antd';
import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 프로모션 상세보기 > 프레젠터
 * ----------------------------------------
 */
const PromotionDetailPresenter = ({
  loading,
  promotionId,
  promotionDetail,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const form1 = [
    {
      label: '프로모션명',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <p>{promotionDetail?.promotion_name}</p>
            </>
          ),
        },
      ],
    },
    {
      label: '기간',
      form: [
        {
          input: (
            <>
              <p>
                {moment(promotionDetail?.promotion_start_date * 1000).format(
                  'YYYY-MM-DD'
                )}{' '}
                ~{' '}
                {moment(promotionDetail?.promotion_end_date * 1000).format(
                  'YYYY-MM-DD'
                )}
              </p>
            </>
          ),
        },
      ],
    },
    {
      label: '적립금액',
      form: [
        {
          input: (
            <>
              <p>5,000원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '할인금액',
      form: [
        {
          input: (
            <>
              <p>5,000원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '쿠폰발행여부',
      form: [
        {
          input: (
            <>
              <p>Y</p>
            </>
          ),
        },
      ],
    },
    {
      label: '카테고리',
      form: [
        {
          input: (
            <>
              <p>원두</p>
            </>
          ),
        },
      ],
    },
    {
      label: '설명',
      form: [
        {
          input: (
            <>
              <p>{promotionDetail?.promotion_description}</p>
            </>
          ),
        },
      ],
    },
  ];

  // 임시 tableData1 생성
  const tableData1 = [
    {
      category: '원두',
      productCode: 'product123456',
      image: '',
      productName: '콜롬비아 수프리모 원두 500g',
      productCost: '25,000원',
    },
  ];

  // 테이블 컴포넌트에 전달할 columns1
  const columns1 = [
    { title: '카테고리', key: 'category' },
    { title: '상품코드', key: 'productCode' },
    { title: '상품 이미지', key: 'image' },
    { title: '상품명', key: 'productName' },
    { title: '판매가', key: 'productCost' },
  ];

  // 임시 tableData2 생성
  const tableData2 = [
    {
      brandName: 'ABC 쇼핑몰',
      ceoName: '홍길동',
      ceoNumber: '010-1234-5678',
      picName: '길동홍',
      picNumber: '010-5678-1234',
      businessHours: '9~6',
    },
  ];

  // 테이블 컴포넌트에 전달할 columns2
  const columns2 = [
    { title: '업체명', key: 'brandName' },
    { title: '대표자명', key: 'ceoName' },
    { title: '대표자 연락처', key: 'ceoNumber' },
    { title: '담당자명', key: 'picName' },
    { title: '담당자 연락처', key: 'picNumber' },
    { title: '영업시간', key: 'businessHours' },
  ];

  // 임시 tableData3 생성
  const tableData3 = [
    {
      category: '원두',
      productCode: 'product123456',
      productName: '콜롬비아 수프리모 원두 500g',
      productCost: '25,000원',
      salesVolume: '231개',
      salesTotal: '5,775,000원',
    },
  ];

  // 테이블 컴포넌트에 전달할 columns3
  const columns3 = [
    { title: '카테고리', key: 'category' },
    { title: '상품코드', key: 'productCode' },
    { title: '상품명', key: 'productName' },
    { title: '판매가', key: 'productCost' },
    { title: '판매량', key: 'salesVolume' },
    { title: '총 판매액', key: 'salesTotal' },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  console.log('promotionDetail: ', promotionDetail);

  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          {/* <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <Empty
              style={{
                height: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
              description={
                <>
                  <Title align={'center'}>개발중입니다.</Title>
                </>
              }
            ></Empty>
          </Content> */}

          <Title style={{ ...styles.title }}>프로모션 상세정보</Title>

          {/* 기본정보 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 20 }}
          >
            <h4
              style={{
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 10,
              }}
            >
              프로모션 정보
            </h4>
            <InputFormTable form={form1} />
          </Content>
          {/* 기본정보 끝 */}

          {/* 상품 목록 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 20 }}
          >
            <h4
              style={{
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 20,
              }}
            >
              해당 상품 목록
            </h4>
            <Table data={tableData1} columns={columns1} />
          </Content>
          {/* 상품 목록 끝 */}

          {/* 참여 업체 목록 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 20 }}
          >
            <h4
              style={{
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 20,
              }}
            >
              참여 업체 목록
            </h4>
            <Table data={tableData2} columns={columns2} />
          </Content>
          {/* 참여 업체 목록 끝 */}

          {/* 판매량 */}
          <Content
            maxWidth={'100%'}
            padding={20}
            borderRadius={4}
            style={{ marginBottom: 20 }}
          >
            <h4
              style={{
                fontSize: 16,
                fontWeight: 500,
                marginBottom: 20,
              }}
            >
              판매량
            </h4>
            <Table data={tableData3} columns={columns3} />
          </Content>
          {/* 판매량 끝 */}

          {/* 버튼 */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                style={{
                  ...styles.button,
                  borderColor: '#EE4700',
                  color: '#EE4700',
                }}
                onClick={() => {
                  window.confirm(`정말 프로모션을 삭제하시겠습니까?`);
                }}
              >
                삭제
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                확인
              </Button>
            </div>
          </Content>
          {/* 버튼 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default PromotionDetailPresenter;
